<wide-dialog-wrapper
  [class]="selectedTab ? selectedTab.id : ''"
  [backgroundColor]="backgroundColor"
  [dialogTitle]="dialogTitle"
  [disabled]="false"
  [deleteTitle]="deleteTitle"
  [deleteText]="deleteText"
  [delete]="canEditMain && !hideDelete"
  [trashRightLabel]="clipLabel"
  [midLeftLabel]="!canEditMain || !canDuplicate ? '' : 'DUPLICATE'"
  [midRightLabel]="midRightLabel"
  [whiteTitle]="whiteTitle"
  successLabel="DONE"
  (onSubmit)="onDone.emit($event)"
  (onMidRight)="onMidRight.emit()"
  (onMidLeft)="onDuplicate.emit($event)"
  (onDelete)="onDelete.emit()"
  (onTrashRight)="onClip.emit()"
>
  <div class="header-reverser" *ngIf="!hideTop">
    <div class="toggle-holder top-right">
      <div style="flex:1;"></div>
      <ng-content select="[manage-header-item]"></ng-content>
      <toggle-tab *ngIf="topToggleText" [bottomTab]="false" [hideToggle]="!canEditMain" [text]="topToggleText" [toggled]="topToggled" (toggle)="onToggle.emit()"></toggle-tab>
      <toggle-tab *ngIf="topSecondToggleText" [bottomTab]="false" [hideToggle]="!canEditMain" [text]="topSecondToggleText" [toggled]="topSecondToggled" (toggle)="onSecondToggle.emit()"></toggle-tab>
      <ng-content select=".in-toggles"></ng-content>
    </div>   
    <div class="manage-header" [ngClass]="{ withStars: showStars }">
      <ng-content select=".beforeTitle"></ng-content>
      <div class="title-holder">
        <icon *ngIf="showCheck" (click)="onCheck.emit()" [ngClass]="{checked: checked, canCheck: !readOnly}" class="task-check-circle" [icon]="checked ?  'task_complete_24px' : 'task_incomplete_24px'"></icon>
        <joi-input #manageTitle class="big-title" [ngClass]="{completed: checked}" [italicPlaceholder]="true"  [type]="'textarea'" [disabled]="!canEditMain" [(model)]="entityTitle" [placeholder]="titlePlaceholder" (joiChange)="emitSaveTitle(entityTitle)"></joi-input>
      
      </div>
      <ng-content select=".dateTime"></ng-content>
      <ng-content select=".aboveLabels"></ng-content>
      <labels-row
        *ngIf="!hideLabels"
        [labelMap]="labelMap"
        [labels]="labels"
        [labelList]="labelList"
        [labelUpdateFunction]="labelUpdateFunction"
        [readOnly]="readOnly || !labelUpdateFunction"
        [type]="type"
        (addLabel)="manageLabels.emit($event)"
      ></labels-row>
      <ng-content select=".afterTitle"></ng-content>
    </div>
  <stars *ngIf="showStars" [maxStars]="MAX_ENTITY_STARS" [stars]="stars" (setStars)="saveStars.emit($event)"></stars>
    
  </div>
  <div class="sticky-divider" [ngClass]="{hidden: !selectedTab}"></div>
  <div #stickyTab class="sticky-tab" [ngClass]="{hidden: !selectedTab}" (click)="onChangeTab.emit()">
    <ng-container *ngIf="selectedTab">
      <icon class="left-arrow" icon="expand18"></icon>
      <div class="tab-name">{{ selectedTab.name }}</div>        
    </ng-container>
  </div>
    <ng-content select=".aboveBody"></ng-content>
    <div class="manage-mobile" *ngIf="!selectedTab && !noTabs">
      <ng-container *ngFor="let tabGroup of tabGroups">
        <h5 class="groupName" *ngIf="tabGroup.groupName">{{ tabGroup.groupName }}</h5>
        <mobile-link-card *ngFor="let tab of tabGroup.tabs; first as first" [title]="tab.name" [borderTop]="!!first" [borderBottom]="true"(click)="onChangeTab.emit(tab)">
          <div *ngIf="!!tab.unseenComments" class="chat_dot">{{ tab.unseenComments }}</div>
        </mobile-link-card>
      </ng-container>
    </div>
    <div class="manage-body" >
      <div class="manage-tabs" *ngIf="!noTabs" [ngClass]="{ hugTop: tabGroups?.length && tabGroups[0].groupName }">
        <ng-container *ngFor="let tabGroup of tabGroups; first as first">
          <h5 class="groupName" *ngIf="tabGroup.groupName">{{ tabGroup.groupName }}</h5>
          <div *ngFor="let tab of tabGroup.tabs; index as i" class="tab" (click)="onChangeTab.emit(tab)" [ngClass]="{ selected: (!selectedTab && !i && first) || tab.id === selectedTab?.id }">
            <icon *ngIf="!!tab.icon" [icon]="tab.icon"></icon>
            <div class="tab-name">{{ tab.name }}</div>
            <div style="flex:1;"></div>
            <div *ngIf="!!tab.unseenComments" class="chat_dot">{{ tab.unseenComments }}</div>
          </div>
        </ng-container>
      </div>

      <div class="manage-inner-panel" 
        [ngClass]="{ 
          mobileHidden: !selectedTab && !noTabs, 
          fullHeight: fullHeight,
          noTabs: noTabs
        }" [ngStyle]="{minHeight: minHeight + 'px'}">
        <ng-content></ng-content>
      </div>
    </div>

</wide-dialog-wrapper>